"use strict";

angular.module("customer")
.factory("HomeService", function($resource, appConfig) {

    return {
        getBanners: function() {
            var service = $resource(appConfig.API_SERVER + "/catalog/customer/home-banner/", {}, {
                query: {
                    method: "get",
                    isArray: true
                }
            });
            return service.query();
        },
        isSelectedFilter: function(selectedValue, value) {
            if (selectedValue.id)
                return value.id == selectedValue.id;
            else
                return value.filter == "all";
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./customer/sections/home/home.service.js
// module id = 891
// module chunks = 0